import React, { Component } from "react";
import {
  setUserLocalStorage,
  getUser,
  logout,
  updateUser
} from "../helper/user_helper";
import Auth from "j-toker";
import YaystackNavBar from "../components/yaystackNavBar";
import UserProfile from "../components/profile/user_profile";
import UserProfileEdit from "../components/profile/user_profile_edit";
import SignInSignUp from "../components/profile/sign_in_sign_up";
import ProfileUpdatePassword from "../components/profile/user_profile_update_password";
import SharingInviteView from "../components/share/sharing_invite_view";
import YAYModalView from "../components/profile/modal/modal_view";
import { ModalViewType } from "../helper/type_helper";

class Profile extends Component {
  state = {
    user: null,
    signedIn: false,
    edit: false,
    errors: "",
    loaded: false,
    openMenu: false,
    editPassword: false,
    showSharingView: false,
    showYayScoreView: false,
    showYaystackTextView: false
  };

  componentDidMount() {
    // Check if user is already login
    if (setUserLocalStorage().signedIn === true) {
      const userLocalStorage = setUserLocalStorage();
      const user = userLocalStorage.user;
      const signedIn = userLocalStorage.signedIn;
      const edit = false;
      const loaded = true;
      this.setState({ user, signedIn, edit, loaded });
    }
    var self = this;
    this.userCall = getUser();
    this.userCall.promise.then(answer => {
      const user = answer.user;
      const signedIn = answer.signedIn;
      const edit = false;
      const loaded = true;
      self.setState({ user, signedIn, edit, loaded });
    });
  }

  componentWillUnmount() {
    if (this.userCall) {
      this.userCall.cancel();
    }
    if (this.userUpdateCall) {
      this.userUpdateCall.cancel();
    }
  }

  render() {
    return (
      <React.Fragment>
        <YaystackNavBar />
        {this.renderProfilePage()}
      </React.Fragment>
    );
  }

  renderProfilePage() {
    if (this.state.signedIn === false || this.state.user == null) {
      return <SignInSignUp />;
    }
    if (this.state.editPassword) {
      return (
        <ProfileUpdatePassword
          updatePassword={this.updatePassword}
          errors={this.state.errors}
          loaded={this.state.loaded}
          handlerUpdatePassword={this.handlerUpdatePassword}
        />
      );
    }
    if (this.state.edit) {
      return (
        <UserProfileEdit
          user={this.state.user}
          handlerEdit={this.handlerEdit}
          handlerSave={this.handlerUpdateUser}
          errors={this.state.errors}
          loaded={this.state.loaded}
        />
      );
    }
    return (
      <React.Fragment>
        <UserProfile
          user={this.state.user}
          username={this.state.user.username}
          me={true}
          handlerLogout={this.handlerLogout}
          handlerEdit={this.handlerEdit}
          loaded={this.state.loaded}
          errors={this.state.errors}
          handlerOpenMenu={this.handlerOpenMenu}
          handlerUpdatePassword={this.handlerUpdatePassword}
          handlerInviteFriend={this.handlerInviteFriend}
          handlerYayScore={this.handlerYayScore}
          handlerGoToBookmarks={this.handlerGoToBookmarks}
          handlerYaystackText={this.handlerYaystackText}
          openMenu={this.state.openMenu}
        />
        {this.renderShareView()}
      </React.Fragment>
    );
  }

  renderShareView() {
    if (this.state.showSharingView) {
      return (
        <SharingInviteView
          handlerInviteFriend={this.handlerInviteFriend}
          username={this.state.user.username}
        />
      );
    }

    if (this.state.showYayScoreView) {
      return (
        <YAYModalView
          user={this.state.user}
          modalView={ModalViewType.yayscore}
          handleCloseView={this.handlerYayScore}
        />
      );
    }

    if (this.state.showYaystackTextView) {
      return (
        <YAYModalView
          user={this.state.user}
          modalView={ModalViewType.send_text}
          handleCloseView={this.handlerYaystackText}
          handlerUpdateUser={this.handlerUpdateUser}
        />
      );
    }
    return <div />;
  }

  handlerOpenMenu = e => {
    const openMenu = !this.state.openMenu;
    this.setState({ openMenu });
  };

  handlerEdit = e => {
    const edit = !this.state.edit;
    const openMenu = false;
    this.setState({ edit, openMenu });
  };

  handlerUpdatePassword = e => {
    const editPassword = !this.state.editPassword;
    const openMenu = false;
    this.setState({ editPassword, openMenu });
  };

  handlerLogout = e => {
    const user = null;
    const signedIn = false;
    const openMenu = false;
    this.setState({ user, signedIn, openMenu });
    logout();
  };

  handlerGoToBookmarks = e => {
    this.props.history.push("/profile/bookmarks");
  };

  handlerYaystackText = e => {
    const openMenu = false;
    const showYaystackTextView = !this.state.showYaystackTextView;
    this.setState({ openMenu, showYaystackTextView });
  };

  handlerUpdateUser = user => {
    var loaded = false;
    this.setState({ loaded });
    const self = this;
    this.userUpdateCall = updateUser(user);
    this.userUpdateCall.promise
      .then(answer => {
        const user = answer.user;
        const signedIn = answer.signedIn;
        const edit = false;
        const loaded = true;
        self.setState({ user, signedIn, edit, loaded });
      })
      .catch(answer => {
        const errors = answer.errors;
        const loaded = true;
        self.setState({ errors, loaded });
      });
  };

  handlerInviteFriend = e => {
    const openMenu = false;
    const showSharingView = !this.state.showSharingView;
    this.setState({ openMenu, showSharingView });
  };

  handlerYayScore = e => {
    const openMenu = false;
    const showYayScoreView = !this.state.showYayScoreView;
    this.setState({ openMenu, showYayScoreView });
  };

  updatePassword = (password, password_confirmation, current_password) => {
    var loaded = false;
    this.setState({ loaded });
    Auth.updatePassword({
      password: password,
      password_confirmation: password_confirmation,
      current_password: current_password
    })
      .then(
        function(user) {
          const editPassword = false;
          const loaded = true;
          this.setState({ editPassword, loaded });
        }.bind(this)
      )

      .fail(
        function(res) {
          var errors = "";
          if (res.data.errors.full_messages) {
            errors = res.data.errors.full_messages.join(", ");
          } else {
            errors = res.data.errors.join(", ");
          }
          this.setState({ errors });
        }.bind(this)
      );
  };
}

export default Profile;



// WEBPACK FOOTER //
// ./src/pages/profile.jsx